module.exports = __webpack_public_path__ + "static/media/guide_word.317377df.png";